<div class="flex flex-col gap-3" *transloco="let t">
  <ng-content />
  @if (!(disabled() || readonly())) {
    <div class="flex items-center gap-2">
      <app-compact-filter [filters]="dealFilterOptions()" (filterChange)="applyFilter($event)" />
      <app-dsp-deal-refresh-button class="ms-auto" />
    </div>
  }
  @if (deals().length === 0) {
    <span class="type-body text-muted-foreground">{{ t("dsp-media-selector.video_deal_no_deal") }}</span>
  } @else {
    <ISelectMenu
      [value]="dealId()"
      (valueChange)="selectDeal($event)"
      [(searchQuery)]="searchQuery"
      popoverWidth="600"
      [disabled]="disabled() || readonly()"
    >
      <ISelectTrigger class="flex w-full">
        <ISelectValue [placeholder]="t('dsp-media-selector.select_deal')">
          <div class="w-full min-w-0" *iSelectValue="let _">
            @if (selectedDeal(); as deal) {
              <app-dsp-deal-option [deal]="deal" />
            }
          </div>
        </ISelectValue>
      </ISelectTrigger>
      <ISelectContent>
        @for (group of dealsToDisplay(); track group.dealType; let first = $first) {
          @if (!first) {
            <IDropdownMenuSeparator />
          }
          <div class="type-label text-muted-foreground truncate px-2 py-1">
            {{ t("dsp-media-selector.deal_type_" + group.dealType) }}
          </div>
          @for (deal of group.deals; track deal.dealId) {
            <ISelectOption [value]="deal.dealId">
              <app-dsp-deal-option [deal]="deal" />
            </ISelectOption>
          }
        }
      </ISelectContent>
    </ISelectMenu>

    @if (enforcedFlightDeal(); as guaranteedDeal) {
      <IAlert>
        {{ t("dsp-media-selector.guaranteed_deal_presets_budget_and_date") }}
      </IAlert>
      <div class="flex max-w-sm flex-col gap-4">
        <IFormField>
          <label iLabel>{{ t("common.budget") }}</label>
          <input
            iInput
            size="sm"
            readonly
            [value]="guaranteedDeal.budget | currency: guaranteedDeal.currency : 'symbol-narrow' : '1.0-2' : locale()"
          />
          @if (guaranteedMaxImpressions(); as impressions) {
            <span class="type-caption text-muted-foreground">
              {{
                t("dsp-media-selector.max_impressions", {
                  impressions: impressions | number: "1.0-0" : locale(),
                })
              }}
            </span>
          }
        </IFormField>
        <IFormField>
          <label iLabel>{{ t("common.dates") }}</label>
          <input iInput size="sm" readonly [value]="guaranteedDateRangeLabel()" />
        </IFormField>
      </div>
    }
  }
</div>
